import { JobPostingLayout } from 'modules/ats/components/job_postings/JobPostingLayout'
import { useJobDetailsContext } from 'modules/ats/pages/JobsPage/JobDetails'

import { PremiumPortalsDataCollection } from './PremiumPortalsDataCollection'

export const JobPostingPremiumPortals = () => {
  const { job } = useJobDetailsContext()

  return (
    <JobPostingLayout job={job}>
      <PremiumPortalsDataCollection atsJobPostingId={job.id} loading={false} />
    </JobPostingLayout>
  )
}
